import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../../components/SEO';

export default function paymentConformation() {
  return (
    <>
    <SEO 
      title="Payment Successful - WorldoTutor"
      description="Your payment has been processed successfully. Thank you for choosing WorldoTutor for your online tutoring needs."
      keywords="payment successful, payment confirmation, worldotutor"
      url="/confirmation"
      type="website"
      noIndex={true}
    />
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="max-w-2xl w-full text-center bg-white rounded-2xl shadow-xl p-8 md:p-12">
        <div className="mx-auto mb-6 w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
          <svg
            className="w-10 h-10 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-neutralBlack mb-3">
          Payment Successful!
        </h1>
        <p className="text-neutralGray2 mb-8 text-lg">
          Thank you for your payment.<br />
          Your transaction has been completed successfully.
        </p>
        <p className="text-neutralGray2 text-base mb-6">
          A confirmation email has been sent to your registered email.
          <br />
          If you have any questions or issues, please contact our support team.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-5 py-3 rounded-lg bg-primary text-white hover:opacity-90 transition font-medium"
          >
            Go to Home
          </Link>
     
        </div>
      </div>
    </div>
    </>
  );
}
